import { a as _objectSpread2 } from './_rollupPluginBabelHelpers-bd852068.js';
import { j as jsx, G as Global } from './emotion-react.esm-95faa810.js';
import { s as styleInject } from './style-inject.es-1f59c1d0.js';
import 'react';
import { baseTheme } from './baseTheme.js';
import { typography } from './typography.js';
import { T as ThemeProvider$1 } from './emotion-element-6bdfffb2.esm-f2337626.js';
import './cjs-9df6abb2.js';
import './scale-15569e54.js';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

(function (module, exports) {
(function (global, factory) {
  factory() ;
}(commonjsGlobal, (function () {
  /**
   * Applies the :focus-visible polyfill at the given scope.
   * A scope in this case is either the top-level Document or a Shadow Root.
   *
   * @param {(Document|ShadowRoot)} scope
   * @see https://github.com/WICG/focus-visible
   */
  function applyFocusVisiblePolyfill(scope) {
    var hadKeyboardEvent = true;
    var hadFocusVisibleRecently = false;
    var hadFocusVisibleRecentlyTimeout = null;

    var inputTypesAllowlist = {
      text: true,
      search: true,
      url: true,
      tel: true,
      email: true,
      password: true,
      number: true,
      date: true,
      month: true,
      week: true,
      time: true,
      datetime: true,
      'datetime-local': true
    };

    /**
     * Helper function for legacy browsers and iframes which sometimes focus
     * elements like document, body, and non-interactive SVG.
     * @param {Element} el
     */
    function isValidFocusTarget(el) {
      if (
        el &&
        el !== document &&
        el.nodeName !== 'HTML' &&
        el.nodeName !== 'BODY' &&
        'classList' in el &&
        'contains' in el.classList
      ) {
        return true;
      }
      return false;
    }

    /**
     * Computes whether the given element should automatically trigger the
     * `focus-visible` class being added, i.e. whether it should always match
     * `:focus-visible` when focused.
     * @param {Element} el
     * @return {boolean}
     */
    function focusTriggersKeyboardModality(el) {
      var type = el.type;
      var tagName = el.tagName;

      if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
        return true;
      }

      if (tagName === 'TEXTAREA' && !el.readOnly) {
        return true;
      }

      if (el.isContentEditable) {
        return true;
      }

      return false;
    }

    /**
     * Add the `focus-visible` class to the given element if it was not added by
     * the author.
     * @param {Element} el
     */
    function addFocusVisibleClass(el) {
      if (el.classList.contains('focus-visible')) {
        return;
      }
      el.classList.add('focus-visible');
      el.setAttribute('data-focus-visible-added', '');
    }

    /**
     * Remove the `focus-visible` class from the given element if it was not
     * originally added by the author.
     * @param {Element} el
     */
    function removeFocusVisibleClass(el) {
      if (!el.hasAttribute('data-focus-visible-added')) {
        return;
      }
      el.classList.remove('focus-visible');
      el.removeAttribute('data-focus-visible-added');
    }

    /**
     * If the most recent user interaction was via the keyboard;
     * and the key press did not include a meta, alt/option, or control key;
     * then the modality is keyboard. Otherwise, the modality is not keyboard.
     * Apply `focus-visible` to any current active element and keep track
     * of our keyboard modality state with `hadKeyboardEvent`.
     * @param {KeyboardEvent} e
     */
    function onKeyDown(e) {
      if (e.metaKey || e.altKey || e.ctrlKey) {
        return;
      }

      if (isValidFocusTarget(scope.activeElement)) {
        addFocusVisibleClass(scope.activeElement);
      }

      hadKeyboardEvent = true;
    }

    /**
     * If at any point a user clicks with a pointing device, ensure that we change
     * the modality away from keyboard.
     * This avoids the situation where a user presses a key on an already focused
     * element, and then clicks on a different element, focusing it with a
     * pointing device, while we still think we're in keyboard modality.
     * @param {Event} e
     */
    function onPointerDown(e) {
      hadKeyboardEvent = false;
    }

    /**
     * On `focus`, add the `focus-visible` class to the target if:
     * - the target received focus as a result of keyboard navigation, or
     * - the event target is an element that will likely require interaction
     *   via the keyboard (e.g. a text box)
     * @param {Event} e
     */
    function onFocus(e) {
      // Prevent IE from focusing the document or HTML element.
      if (!isValidFocusTarget(e.target)) {
        return;
      }

      if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
        addFocusVisibleClass(e.target);
      }
    }

    /**
     * On `blur`, remove the `focus-visible` class from the target.
     * @param {Event} e
     */
    function onBlur(e) {
      if (!isValidFocusTarget(e.target)) {
        return;
      }

      if (
        e.target.classList.contains('focus-visible') ||
        e.target.hasAttribute('data-focus-visible-added')
      ) {
        // To detect a tab/window switch, we look for a blur event followed
        // rapidly by a visibility change.
        // If we don't see a visibility change within 100ms, it's probably a
        // regular focus change.
        hadFocusVisibleRecently = true;
        window.clearTimeout(hadFocusVisibleRecentlyTimeout);
        hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
          hadFocusVisibleRecently = false;
        }, 100);
        removeFocusVisibleClass(e.target);
      }
    }

    /**
     * If the user changes tabs, keep track of whether or not the previously
     * focused element had .focus-visible.
     * @param {Event} e
     */
    function onVisibilityChange(e) {
      if (document.visibilityState === 'hidden') {
        // If the tab becomes active again, the browser will handle calling focus
        // on the element (Safari actually calls it twice).
        // If this tab change caused a blur on an element with focus-visible,
        // re-apply the class when the user switches back to the tab.
        if (hadFocusVisibleRecently) {
          hadKeyboardEvent = true;
        }
        addInitialPointerMoveListeners();
      }
    }

    /**
     * Add a group of listeners to detect usage of any pointing devices.
     * These listeners will be added when the polyfill first loads, and anytime
     * the window is blurred, so that they are active when the window regains
     * focus.
     */
    function addInitialPointerMoveListeners() {
      document.addEventListener('mousemove', onInitialPointerMove);
      document.addEventListener('mousedown', onInitialPointerMove);
      document.addEventListener('mouseup', onInitialPointerMove);
      document.addEventListener('pointermove', onInitialPointerMove);
      document.addEventListener('pointerdown', onInitialPointerMove);
      document.addEventListener('pointerup', onInitialPointerMove);
      document.addEventListener('touchmove', onInitialPointerMove);
      document.addEventListener('touchstart', onInitialPointerMove);
      document.addEventListener('touchend', onInitialPointerMove);
    }

    function removeInitialPointerMoveListeners() {
      document.removeEventListener('mousemove', onInitialPointerMove);
      document.removeEventListener('mousedown', onInitialPointerMove);
      document.removeEventListener('mouseup', onInitialPointerMove);
      document.removeEventListener('pointermove', onInitialPointerMove);
      document.removeEventListener('pointerdown', onInitialPointerMove);
      document.removeEventListener('pointerup', onInitialPointerMove);
      document.removeEventListener('touchmove', onInitialPointerMove);
      document.removeEventListener('touchstart', onInitialPointerMove);
      document.removeEventListener('touchend', onInitialPointerMove);
    }

    /**
     * When the polfyill first loads, assume the user is in keyboard modality.
     * If any event is received from a pointing device (e.g. mouse, pointer,
     * touch), turn off keyboard modality.
     * This accounts for situations where focus enters the page from the URL bar.
     * @param {Event} e
     */
    function onInitialPointerMove(e) {
      // Work around a Safari quirk that fires a mousemove on <html> whenever the
      // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
      if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
        return;
      }

      hadKeyboardEvent = false;
      removeInitialPointerMoveListeners();
    }

    // For some kinds of state, we are interested in changes at the global scope
    // only. For example, global pointer input, global key presses and global
    // visibility change should affect the state at every scope:
    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('mousedown', onPointerDown, true);
    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('touchstart', onPointerDown, true);
    document.addEventListener('visibilitychange', onVisibilityChange, true);

    addInitialPointerMoveListeners();

    // For focus and blur, we specifically care about state changes in the local
    // scope. This is because focus / blur events that originate from within a
    // shadow root are not re-dispatched from the host element if it was already
    // the active element in its own scope:
    scope.addEventListener('focus', onFocus, true);
    scope.addEventListener('blur', onBlur, true);

    // We detect that a node is a ShadowRoot by ensuring that it is a
    // DocumentFragment and also has a host property. This check covers native
    // implementation and polyfill implementation transparently. If we only cared
    // about the native implementation, we could just check if the scope was
    // an instance of a ShadowRoot.
    if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
      // Since a ShadowRoot is a special kind of DocumentFragment, it does not
      // have a root element to add a class to. So, we add this attribute to the
      // host element instead:
      scope.host.setAttribute('data-js-focus-visible', '');
    } else if (scope.nodeType === Node.DOCUMENT_NODE) {
      document.documentElement.classList.add('js-focus-visible');
      document.documentElement.setAttribute('data-js-focus-visible', '');
    }
  }

  // It is important to wrap all references to global window and document in
  // these checks to support server-side rendering use cases
  // @see https://github.com/WICG/focus-visible/issues/199
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    // Make the polyfill helper globally available. This can be used as a signal
    // to interested libraries that wish to coordinate with the polyfill for e.g.,
    // applying the polyfill to a shadow root:
    window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;

    // Notify interested libraries of the polyfill's presence, in case the
    // polyfill was loaded lazily:
    var event;

    try {
      event = new CustomEvent('focus-visible-polyfill-ready');
    } catch (error) {
      // IE11 does not support using CustomEvent as a constructor directly:
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
    }

    window.dispatchEvent(event);
  }

  if (typeof document !== 'undefined') {
    // Apply the polyfill to the global document, so that no JavaScript
    // coordination is required to use the polyfill in the top-level document:
    applyFocusVisiblePolyfill(document);
  }

})));
}());

var css_248z = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers.\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Render the `main` element consistently in IE.\n */\n\nmain {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * Remove the gray background on active links in IE 10.\n */\n\na {\n  background-color: transparent;\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57-\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove the border on images inside links in IE 10.\n */\n\nimg {\n  border-style: none;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers.\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Remove the default vertical scrollbar in IE 10+.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10.\n * 2. Remove the padding in IE 10.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in Edge, IE 10+, and Firefox.\n */\n\ndetails {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Misc\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10+.\n */\n\ntemplate {\n  display: none;\n}\n\n/**\n * Add the correct display in IE 10.\n */\n\n[hidden] {\n  display: none;\n}\n";
styleInject(css_248z);

/**
 * Component for providing theme context for app.
 */
var ThemeProvider = function ThemeProvider(_ref) {
  var _global$fonts;
  var theme = _ref.theme,
    children = _ref.children;
  var global = theme.global || baseTheme.global;
  var fontFaceStyles = ((_global$fonts = global.fonts) === null || _global$fonts === void 0 ? void 0 : _global$fonts.fontFace) || [];
  var _ref2 = global.base || baseTheme.global.base,
    selection = _ref2.selection,
    focus = _ref2.focus,
    body = _ref2.body,
    css = _ref2.css;
  var baseStyles = [{
    '*, ::before, ::after': {
      boxSizing: 'border-box',
      padding: 0,
      margin: 0
    },
    '::selection': _objectSpread2({
      color: selection === null || selection === void 0 ? void 0 : selection.color,
      backgroundColor: selection === null || selection === void 0 ? void 0 : selection.bg
    }, selection === null || selection === void 0 ? void 0 : selection.css),
    ':focus': _objectSpread2({
      outline: "".concat((focus === null || focus === void 0 ? void 0 : focus.width) || 2, "px solid ").concat((focus === null || focus === void 0 ? void 0 : focus.color) || baseTheme.colors.black),
      outlineOffset: focus === null || focus === void 0 ? void 0 : focus.offset
    }, focus === null || focus === void 0 ? void 0 : focus.css),
    '.js-focus-visible :focus:not(.focus-visible)': {
      outline: 'none'
    },
    'html, body': {
      minHeight: '100%'
    },
    body: _objectSpread2(_objectSpread2({}, body && typography(body.typography, theme.typography ? theme : baseTheme)), {}, {
      color: body === null || body === void 0 ? void 0 : body.color,
      backgroundColor: body === null || body === void 0 ? void 0 : body.bg
    }, body === null || body === void 0 ? void 0 : body.css),
    img: {
      maxWidth: '100%',
      height: 'auto'
    },
    a: {
      display: 'inline-block',
      textDecoration: 'none',
      color: 'inherit'
    },
    'h1, h2, h3, h4, h5, h6': {
      margin: 0
    },
    'ul li, ol li': {
      listStyle: 'none'
    },
    button: {
      border: 'none',
      background: 'none',
      cursor: 'pointer'
    },
    'input[type="number"]': {
      appearance: 'textfield'
    },
    'input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button': {
      margin: 0,
      appearance: 'none'
    },
    fieldset: {
      padding: 0,
      border: 'none'
    }
  }];
  return jsx(ThemeProvider$1, {
    theme: theme
  }, jsx(Global, {
    styles: [fontFaceStyles, baseStyles, css, process.env.NODE_ENV === "production" ? "" : ";label:ThemeProvider;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:ThemeProvider;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
  }), children);
};

export { ThemeProvider };
